module.exports = __webpack_public_path__ + "static/img/haibaob7e15bd.jpg";